import { PopupConfig } from "@smile2impress/popups";
import { Popup } from "api/cms-website/cms-popups.types";

import { getCmsPopupConfigs } from "./cmsPopups";

const popupsConfig = (cmsPopups?: Popup[]): PopupConfig[] => [
    // Quiz-link popups are now CMS-driven (see cms-data/cms-popups.json).
    // `cmsPopups` overrides the JSON in preview mode.
    ...getCmsPopupConfigs(cmsPopups),
];

export default popupsConfig;
